export const ESTADO_LIQUIDACION = {
    EN_PREPARACION: 2,
    LIQUIDADA: 3,
    CALCULADA: 5,
};

const MODIFIER_POR_ESTADO = {
    [ESTADO_LIQUIDACION.EN_PREPARACION]: 'preparacion',
    [ESTADO_LIQUIDACION.LIQUIDADA]: 'liquidada',
    [ESTADO_LIQUIDACION.CALCULADA]: 'calculada',
};

export const OPCION_ESTADO_CALCULADA = {
    label: 'Calculada',
    value: String(ESTADO_LIQUIDACION.CALCULADA),
};

// El texto lo define el backend (tipoEstadoLiquidacionMostrar); el id solo determina el color.
export const getEstadoLiquidacion = (liquidacion) => {
    const encabezado = liquidacion?.encabezadoLiquidacion ?? {};
    const id = Number(
        liquidacion?.idTipoEstadoLiquidacion
        ?? liquidacion?.IdTipoEstadoLiquidacion
        ?? encabezado.idTipoEstadoLiquidacion
        ?? encabezado.IdTipoEstadoLiquidacion
    );
    const label = String(
        liquidacion?.tipoEstadoLiquidacionMostrar
        ?? liquidacion?.TipoEstadoLiquidacionMostrar
        ?? encabezado.tipoEstadoLiquidacionMostrar
        ?? encabezado.TipoEstadoLiquidacionMostrar
        ?? ''
    ).trim();

    return {
        id,
        label,
        modifier: MODIFIER_POR_ESTADO[id] ?? 'preparacion',
    };
};

// Garantiza que el filtro ofrezca "Calculada" aunque el servicio de estados no la devuelva.
export const agregarEstadoCalculada = (opciones) => {
    const lista = Array.isArray(opciones) ? opciones : [];
    return lista.some((o) => String(o?.value) === OPCION_ESTADO_CALCULADA.value)
        ? lista
        : [...lista, OPCION_ESTADO_CALCULADA];
};
